import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@material-ui/core';
import * as React from 'react';

interface Props {
  title: string;
  emailList: string[];
  ignoreList: string[];
  isOpen: boolean;
  handleClose: () => void;
};

export const BulkResponseDialog: React.FC<Props> = (prop: Props) => {
  let stripeLink: string = process.env.NODE_ENV === 'production' ?
    'https://dashboard.stripe.com/subscriptions/' : 'https://dashboard.stripe.com/test/subscriptions/';

  return (
    <Dialog
      open={prop.isOpen}
      scroll={'paper'}
      onClose={prop.handleClose}>
      <DialogTitle>{prop.title}</DialogTitle>
      <DialogContent dividers={true}>
        <TextField
          multiline
          fullWidth
          value={prop.emailList.map(item => item).join(', \n')} />
      </DialogContent>
      {prop.ignoreList.length > 0 &&
        <>
          <DialogTitle>There was an error while processing the following Stripe ID's</DialogTitle>
          <DialogContent dividers={true}>
            {prop.ignoreList.map(id =>
              <div>
                <a target="_blank" rel="noreferrer" href={`${stripeLink + id}`}>{id}</a>
                <br></br>
              </div>
            )}
          </DialogContent>
        </>}
      <DialogActions>
        <Button onClick={prop.handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}